import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {InfoTileComponent} from '@components/info-tile/info-tile.component';
import {PlacementService} from '@services/placement.service';

@Component({
    selector: 'app-vaccination-stats',
    standalone: true,
    imports: [InfoTileComponent],
    templateUrl: './vaccination-stats.component.html',
    styleUrl: './vaccination-stats.component.scss'
})
export class VaccinationStatsComponent implements OnChanges {
    @Input() placementId: number | null = null;

    vaccinationStats: any = {
        totalVaccinations: 0,
        dayOfTheCycle: 0, //day[s] of the cycle
        finishedPrograms: 0
    };

    constructor(private placementService: PlacementService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['placementId'] && this.placementId) {
            console.log(
                'MortalityStatsComponent: fetching data for placement ID:',
                this.placementId
            );
            this.getTotalVaccinations(this.placementId);
        }
    }

    getTotalVaccinations(placementId: number): void {
        this.placementService
            .GetActivePlacementVaccinationData(placementId)
            .subscribe({
                next: (response) => {
                    this.vaccinationStats = response;
                },
                error: (error) => {
                    console.error('VaccinationStatsComponent error:', error);
                }
            });
    }
}
